import { __decorate } from "tslib";
import { Component, Prop, Model, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
let Navigation = class Navigation extends Vue {
    constructor() {
        super(...arguments);
        this.list = [{ text: '主页', icon: 'home', path: '/' }];
    }
    changed(event) {
        this.$emit('input', event);
    }
    created() {
        this.getNavList();
    }
    get idrawer() {
        return this.drawer;
    }
    set idrawer(val) {
        this.$emit('input', val);
    }
    itemSelect(item) {
        this.$emit('selected', item);
        this.$emit('input', false);
    }
    async getNavList() {
        const that = this;
        try {
            let res;
            // 登陆过程已经获取过用户权限信息，若未能从store中获取相应权限，则重新从接口中获取
            if (!Object.keys(that.currentPrivileges || {}).length)
                res = ((await that.axios.get('/api/privileges/elements/current')).data.result) || [];
            else {
                res = that.currentPrivileges.element.map((v) => v.info);
            }
            if (!res.length) {
                console.log('当前用户无未有查看页面的权限');
                // that.snackbar.warn('当前用户无未有查看页面的权限')
                return;
            }
            const lRoot = [];
            res.filter((v) => v.type === '路由').map((v) => {
                v['text'] = v.name;
                return v;
            }).forEach((v) => {
                if (!v.pid) {
                    lRoot.push(v);
                }
            });
            res.forEach((v) => {
                if (v.pid) {
                    const rIt = lRoot.find(vr => vr.id === v.pid);
                    if (rIt) {
                        rIt['children'] = (rIt['children'] || []).concat([v]);
                    }
                }
            });
            that.list = lRoot.sort((a, b) => a.code - b.code).map((v) => (!v.children ? v : { ...v, children: v.children.sort((sa, sb) => sa.code - sb.code) }));
        }
        catch (e) {
            console.log('error of get navigation list:', e);
        }
    }
};
__decorate([
    Prop()
], Navigation.prototype, "autoLoadPath", void 0);
__decorate([
    Getter
], Navigation.prototype, "currentPrivileges", void 0);
__decorate([
    Model('input', { type: Boolean })
], Navigation.prototype, "drawer", void 0);
Navigation = __decorate([
    Component({
        methods: {},
        data: () => ({}),
    })
], Navigation);
export default Navigation;
